import { render, staticRenderFns } from "./CardPatient.vue?vue&type=template&id=1270e87a&"
import script from "./CardPatient.vue?vue&type=script&lang=js&"
export * from "./CardPatient.vue?vue&type=script&lang=js&"
import style0 from "./CardPatient.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports